import {Component, ViewChild} from "@angular/core";
import {SimpleModal} from "fly-common/simple-modal.component";

@Component({
	selector: "purchasing-disabled",
	template: `
		<simple-modal
			title="Unable To Add Items To Cart"
			*ngIf="showModal"
			(close)="showModal = false"
		>
			<p>
				Purchasing databases from flyGarmin has been disabled for this account. Please contact your fleet
				administrator for more details.
			</p>
		</simple-modal>
	`,
})
export class PurchasingDisabledModalComponent {
	@ViewChild(SimpleModal) textModal: SimpleModal;
	showModal = false;

	open() {
		this.showModal = true;
	}
}
